class TabHandler {

  constructor() {
    this.listener()
  }

  listener() {
    this.activateTabByParams()

    let tabs = document.querySelector('.eventTabs__inner')
    if (tabs) {
      tabs.addEventListener('click', ev => {
        if (ev.target.classList.contains('eventTabs__tab--active')) return;
        if (ev.target.classList.contains('eventTabs__tab')) {
          let tabTarget = ev.target.value
          this.closeOldOpenNew(tabTarget)
          this.addToAddress(tabTarget)
        }
      })
    }
  }

  addToAddress(tabTarget) {
    window.history.replaceState(null, null, "?tab=" + tabTarget)
  }

  activateTabByParams() {
    const queryString = window.location.search
    const params = new URLSearchParams(queryString)
    if (params.has('tab')) {
      this.closeOldOpenNew(params.get('tab'))
    }
  }

  closeOldOpenNew(tabTarget) {
    // Buttons
    let oldBtn = document.querySelector('.eventTabs__tab--active')
    if (oldBtn) {
      oldBtn.classList.remove('eventTabs__tab--active')
    }

    // Content
    let hide = document.querySelector('.event__tab--active')
    if (hide) {
      hide.classList.remove('event__tab--active')
    } else { // Form is open
      document.querySelector('.zoomForm:not(.zoomForm--hidden)').classList.add('zoomForm--hidden')
      // Remove autumn 2023, backwards compatibility
      let activeOldButton = document.querySelector('#hubspot_form_button')
      if (activeOldButton) {
        activeOldButton.classList.remove('button--active')
      }
      // END
      let activeButton = document.querySelector('.button--register.button--active')
      if (activeButton) {
        activeButton.classList.remove('button--active')
      }
    }
    let newBtn = document.querySelector(`[value=${tabTarget}]`)
    newBtn.classList.add('eventTabs__tab--active')
    let show = document.querySelector(`[data-tab=${tabTarget}]`)
    if (show) {
      show.classList.add('event__tab--active')
    }
  }


}

export default TabHandler